import type { Me } from '@volee/api-client'
import { INTERNAL_MAIL_DOMAIN } from '@volee/config'

/** What the person signs in with, as the app names the account: a child with no mail of their own by
 *  the username, never by the internal mail behind it (VOL-92). */
export function signInNameOf(me: Pick<Me, 'email' | 'email_is_real' | 'username'>): string {
  return !me.email_is_real && me.username != null ? me.username : me.email
}

/** A username has no inbox behind it: what a child with no mail types where a mail goes. The one test of
 *  which of the two a person typed (spec #278, #294). */
export function isUsername(identifier: string): boolean {
  return !identifier.includes('@')
}

/** What Cognito signs in with, from what the person typed: a mail as it is, a child's username as
 *  the internal mail behind it. The one place the app composes it (spec #278, #294). */
export function signInEmailOf(identifier: string): string {
  const typed = identifier.trim()
  return isUsername(typed) ? `${typed.toLowerCase()}@${INTERNAL_MAIL_DOMAIN}` : typed
}
